/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import proImg from '../../../../../public/media/auth/user.png'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
    <div className='d-flex styMain'>
      <div className="proImg">
        <img
              alt='Logo'
              className='h-70px logo'
              src={toAbsoluteUrl('/media/logos/user.png')}
              
            />
      </div>
      <div className="details">
              <ul>
                    <li>#ENP120092</li>
                    <li>Mr. Kofi Mensah</li>
                    <li>kofimensah@enp.com</li>
                    <li>Operations Manager</li>
                </ul>
      </div>
    </div>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title="Appraisal"
        fontIcon='bi bi-people fs-2'
      />
      {/* <AsideMenuItem
        to='#'
        title='Appraisal'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >       
      </AsideMenuItem> */}
      <AsideMenuItem
        to='#'
        title='Disciplinary'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >       
      </AsideMenuItem>
      <AsideMenuItem
        to='#'
        title='Leave'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >       
      </AsideMenuItem>
      <AsideMenuItem
        to='#'
        title='Medical'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >       
      </AsideMenuItem>
      <AsideMenuItem
        to='#'
        title='Notifications'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >       
      </AsideMenuItem>
      <AsideMenuItem
        to='#'
        title='Timesheet'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >       
      </AsideMenuItem>
      <AsideMenuItem
        to='#'
        title='Settings'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >       
      </AsideMenuItem>
    
    </>
  )
}


